// extracted by mini-css-extract-plugin
export default {"mainReviewsWrapper":"sG-z"};